<template>
    <div class="page_visits" :class="{'simple':simple}" v-if="info.monitor || info.admin">
        <div class="container">
            <div v-if="!simple">
                <div class="page_visit_block">
                    <h3>权限开放列表
                        <div class="close_btn" @click="simple=true">收起详情 <a-icon type="up" /></div>
                        <a-radio-group v-model="type" class="type_btn">
                            <a-radio-button value="month_visits">本月查看天数</a-radio-button>
                            <a-radio-button value="all_visits">总查看天数</a-radio-button>
                        </a-radio-group>
                    </h3>
                    <div v-for="user_type in types.user" :key="user_type.type" v-show="admin || user_type.type=='pd'">
                        <a-row>
                            <a-col :span="1">
                                <h4>{{user_type.title}}：</h4>
                            </a-col>
                            <a-col :span="23">
                                <a-row v-if="users[`now_${user_type.type}`].length==0">
                                    <a-col>无</a-col>
                                </a-row>
                                <a-row :gutter="10" v-if="users[`now_${user_type.type}`].length>0">
                                    <a-col :span="2" v-for="(user, index) in users[`now_${user_type.type}`]" :key="`${user_type.type}_${index}`" class="page_visit_item">
                                        <span class="name">{{user.name}}</span>
                                        <a-tag color="orange" style="margin:0 0 0 5px;">{{user[type]}}</a-tag>
                                    </a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                    </div>
                </div>
                <div class="page_visit_block">
                    <h3>权限历史开放列表</h3>
                    <div v-for="user_type in types.user" :key="user_type.type" v-show="admin || user_type.type=='pd'">
                        <a-row>
                            <a-col :span="1">
                                <h4>{{user_type.title}}：</h4>
                            </a-col>
                            <a-col :span="23">
                                <a-row v-if="users[`history_${user_type.type}`].length==0">
                                    <a-col>无</a-col>
                                </a-row>
                                <a-row v-if="users[`history_${user_type.type}`].length>0">
                                    <span v-for="(user, index) in users[`history_${user_type.type}`]" :key="`${user_type.type}_${index}`" style="margin:0 8px 5px 0">{{user.name}}</span>
                                </a-row>
                            </a-col>
                        </a-row>
                    </div>
                </div>
            </div>
            <div v-if="simple">
                <div class="page_visit_block">
                    <h3>权限开放对象</h3>
                    <div class="close_btn" @click="simple=false">展开详情 <a-icon type="down" /></div>
                    <div class="page_visit_item_list">
                        <template v-for="user_type in types.user" v-show="admin || user_type.type=='pd'">
                            <span class="name" v-for="(user, index) in users[`now_${user_type.type}`]" :key="`${user_type.type}_${index}`" style="margin:0 8px 0 0">{{user.name}}</span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Radio, Tag} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Radio)
Vue.use(Tag)

export default {
    watch: {
        $route() {
            this.simple = true
            this.getVisit()
        },
    },
    computed: {
        users() {
            let users = {
                now_pd: [],
                now_ux: [],
                history_pd: [],
                history_ux: [],
            }
            this.visits.forEach((v) => {
                if(v.history==false) {
                    if(v.staff==false) {
                        users.now_pd.push(v)
                    }
                    else {
                        users.now_ux.push(v)
                    }
                }
                else {
                    if(v.staff==false) {
                        users.history_pd.push(v)
                    }
                    else {
                        users.history_ux.push(v)
                    }

                }
            });
            return users
        },
        info() {
            return this.$store.state.game.info
        },
        admin() {
            return (this.info.monitor && this.$store.state.user.staff) || this.info.admin
        },
    },
    data() {
        return {
            visits: [],
            types: {
                history: [
                    {title: '权限开放列表', type: 'now'}, 
                    {title: '权限历史开放列表', type: 'history'}
                ],
                user: [
                    {title: '产品', type: 'pd'}, 
                    {title: ' U X ', type: 'ux'}
                ],
            },
            simple: true,
            type: 'month_visits'
        }
    },
    mounted() {
        this.getVisit()
    },
    methods: {
        // 获取页面查看信息
        getVisit() {
            if(this.info.monitor || this.info.admin) {
                this.visits = []
                let page_id = null, type="page"
                if(this.$route.name=='page') {
                    page_id = this.$route.query.id
                    type = "page"
                }
                else {
                    page_id = this.$route.meta.id
                    type = "fixed"
                }
                this.$nextTick(()=>{
                    this.$service.getData(`${this.$service.api.project.page_visit}${page_id}/`, {type}).then((data)=>{
                        this.visits = data
                    })
                })
            }
        },
    },
}
</script>


<style lang="less" scoped>
.page_visits {
    background: #e6f7ff;
    border-bottom: 1px solid #1890ff;
    //padding:20px 0;

    .page_visit_block {
        padding:20px 0;
        h3 {
            font-weight: bold;
            height:35px;
        }
        .type_btn {
            font-weight: normal;
            float:right;
            margin-bottom:10px;
        }
        .close_btn {
            font-weight: normal;
            float:right;
            font-size:14px;
            line-height: 32px;
            margin:0 0 0 20px;
            color:#1890ff;
            cursor: pointer;
        }
        h4 {
            float:left;
            width:60px;
        }
        .page_visit_item {
            display: flex;
            justify-content: space-between;
            margin-bottom:5px;
            span.name {
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .ant-tag-orange {
                min-width: 50px;
                text-align: center;
            }
        }
        &:nth-child(2) {
            border-top:1px solid #ddd;
            color: #aaa;
            h3,h4 {
                color: #aaa;
            }
        }
    }
    &.simple {
        .page_visit_block {
            padding:10px 0;
            line-height: 32px;
            overflow:hidden;
            .page_visit_item_list {
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                margin:0 100px 0 130px;
            }
            h3 {
                width:130px; 
                margin:0;
                float:left;
            }
            .close_btn{
                width:90px;
                margin:0;
                float:right;
            }
        }
        // .page_visit_block {
        //     padding:10px 0;
        //     display: flex;
        //     flex-direction: vertical;
        //     line-height: 32px;
        //     .page_visit_item_list {
        //         overflow: hidden;
        //         text-overflow:ellipsis;
        //         white-space: nowrap;
        //     }
        //     h3 {
        //         width:130px; 
        //         flex-basis:130px;
        //         margin:0;
        //     }
        //     .close_btn{
        //         float:none;
        //         align-self:flex-end;
        //         width:90px;
        //         flex-basis: 90px;
        //     }
        // }
    }
}
</style>